module.exports = __webpack_public_path__ + "static/halfling_male_SCAG-601307b46af07780a9965d7858c6f466.png";